
export class GlobalData {
     public static unitList = [];
     public static templeMaterialList = [];
    public static bankList = [];
    public static deityList = [];
    public static categoryList = [];
    public static auditoriumList = [];
    public static poojaList = [];
    public static accountHeadExpenseList = [];
    public static accountHeadIncomeList = [];
    public static menus = [
       
      //  { api: 'account-head/bank', array: GlobalData.bankList},
    //    {api:'temple/deity', array:GlobalData.deityList},
    //    {api:'category', array:GlobalData.categoryList},
    //    {api:'auditorium', array:GlobalData.auditoriumList},
    //    {api:'temple/pooja', array:GlobalData.poojaList},
    //    {api:'temple/material', array:GlobalData.templeMaterialList},
  {api:'unit', array:GlobalData.unitList},
    //  nopost  {api:'account-head/expense',array:GlobalData.accountHeadExpenseList}
    //  nopost  {api:'account-head/income',array:GlobalData.accountHeadIncomeList}

    ]

}
